import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_AppErrorField = _resolveComponent("AppErrorField")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, "Welcome " + _toDisplayString(_ctx.cognitoUser.username), 1),
    _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Please, create a new Password", -1)),
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { prop: "password" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.newPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.newPassword) = $event)),
              type: "password",
              placeholder: "New password",
              "prefix-icon": _ctx.Lock
            }, null, 8, ["modelValue", "prefix-icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppErrorField, { error: _ctx.errorMsg }, null, 8, ["error"]),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "w-100",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePassword(_ctx.cognitoUser)))
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" CHANGE PASSWORD ")
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        })
      ]),
      _: 1,
      __: [3]
    }, 8, ["model", "rules"])
  ], 64))
}